module.exports = __webpack_public_path__ + "img/edev.9e327f7b.svg";